// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"13b33e81","453":"bf6a8c68","805":"b5a22330"}[chunkId] + ".chunk.js";
};